import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useParams, useNavigate } from "react-router-dom";
import {
  getSurveyForm,
  updateSurveyParticipantResponsesStatus,
} from "../../Utils/surveyFunctions";
import { ToastContainer, toast } from "react-toastify";

let SurveyParticipantQualification = () => {
  const { ip_address } = useContext(globalInfo);
  const { formKey } = useParams();
  const navigate = useNavigate();
  const [qualificationJson, setQualificationJson] = useState("");
  const [surveyName, setSurveyName] = useState("");
  const [surveyID, setSurveyID] = useState("");
  const [participantID, setParticipantID] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [deviceLogo, setDeviceLogo] = useState("");
  const [inputList, setInputList] = useState([{ question: "", answer: "" }]);
  const [answer1, setAnswers] = useState([]);
  const [selectedAnswer, setselectedAnswer] = useState([]);
  const [requiredError, setRequiredError] = useState("");
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSurveyForm(formKey);
      if (response.status == "success") {
        setInputList(JSON.parse(response.getParticipantQualifications));
        if (
          response.getSurveyStatus === "completed" ||
          response.getSurveyStatus === "survey_closed" ||
          response.getSurveyStatus === "final_save" ||
          response.getSurveyStatus === "survey_approved"
        ) {
          navigate("/SurveyClosed");
          return false;
        } else if (
          response.getParticipantLastAction.includes("survey_attempted")
        ) {
          navigate("/survey-already-taken");
          return false;
        } else if (response.getParticipantLastAction.includes("disqualified")) {
          navigate("/SurveyNotEligible");
          return false;
        }

        let questions = JSON.parse(response.getParticipantQualifications).map(
          (item, i) => (
            <tr key={i++}>
              <td>{item.question}</td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                <input
                  className={"participant_qualification_questions_" + i}
                  type="radio"
                  name={item.question}
                  value="yes"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                <input
                  className={"participant_qualification_questions_" + i}
                  type="radio"
                  name={item.question}
                  value="no"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </td>
            </tr>
          )
        );

        setQualificationJson(questions);
        setSurveyName(response.getSurveyName);
        setCompanyLogo(response.getCompanyLogo);
        setDeviceLogo(response.getDeviceLogo);
        setSurveyID(response.getSurveyID);
        setParticipantID(response.getParticipantID);
      } else {
        setIsError(true);
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, [answer1]);
  const handleChange = (e) => {
    const question = e.target.name;
    const answer = { question, answer: e.target.value };
    setselectedAnswer(answer);
    setAnswers((answers) => [...answers, answer]);
  };
  let answers;
  if (answer1.length > 0) {
    answers = answer1.map((ele) => {
      if (ele.question === selectedAnswer.question) {
        ele.answer = selectedAnswer.answer;
      }
      return getUnique(answer1, "question");
    });
  }
  function getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }
  const submitParticipantQualification = async (e) => {
    e.preventDefault();
    let countAnswer = 0;
    let qualificationStatus;

    if (answer1.length > 0) {
      let qualified = [];
      const myanswers = getUnique(answers[0], "question");
      countAnswer = myanswers.length;
      inputList.forEach((ele, i) => {
        if (
          ele.question === myanswers[i].question &&
          ele.answer !== myanswers[i].answer
        ) {
          qualified.push("notqualified");
        }
      });
      qualificationStatus = "qualified";
      if (qualified.length > 0) {
        qualificationStatus = "disqualified";
      }
    }
    if (inputList.length !== countAnswer) {
      setRequiredError("Please fill required field.");
      return false;
    } else {
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("participant_id", participantID);

      bodyFormData.append("status", qualificationStatus);
      bodyFormData.append("ip_address", ip_address);
      const response = await updateSurveyParticipantResponsesStatus(
        bodyFormData
      );
      if (response.status == "success") {
        if (qualificationStatus === "qualified") {
          navigate("/SurveyConsent/" + formKey);
        } else {
          navigate("/SurveyNotEligible/");
        }
      } else {
        toast.warning(response.message, { autoClose: 1500 });
      }
      setRequiredError("");
      return true;
    }
  };

  return (
    <div>
      {isError === false && (
        <>
          <ToastContainer></ToastContainer>
          <div className="container-fluid custom-container-fluid-background-survey">
            <div className="survey-header">
              <div className="row">
                <div className="offset-md-1 col-md-10 offset-md-1">
                  <div className="form-box">
                    <center>
                      <img
                        src={companyLogo}
                        alt="image not available"
                        height={35}
                      ></img>
                    </center>
                  </div>
                </div>
              </div>

              <div className="row form-box-top-margin">
                <div className="offset-md-1 col-md-10 offset-md-1">
                  <div className="form-box device-box">
                    <center>
                      <center>
                        <img
                          src={deviceLogo}
                          alt="image not available"
                          className="form-box-device-image"
                        ></img>
                      </center>
                      <br></br>
                      <h6>
                        <b>{surveyName}</b>
                      </h6>
                    </center>
                  </div>
                </div>
              </div>

              <div className="row form-box-top-margin">
                <div className="offset-md-1 col-md-10 offset-md-1">
                  <div className="form-box">
                    <table className="table table-bordered form-box-table">
                      <colgroup>
                        <col span={1} style={{ width: "70%" }} />
                        <col span={1} style={{ width: "15%" }} />
                        <col span={1} style={{ width: "15%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th style={{ verticalAlign: "middle !important" }}>
                            Participant Qualification
                          </th>
                          <th
                            className="text-center"
                            style={{ verticalAlign: "middle" }}
                          >
                            Yes
                          </th>
                          <th
                            className="text-center"
                            style={{ verticalAlign: "middle !important" }}
                          >
                            No
                          </th>
                        </tr>
                      </thead>
                      <tbody>{qualificationJson}</tbody>
                    </table>
                    {requiredError && (
                      <span className="text-left text-danger">
                        {requiredError}
                      </span>
                    )}
                    <center>
                      <button
                        type="button"
                        className="btn btn-sm custom-btn-primary pull-right"
                        onClick={submitParticipantQualification}
                      >
                        Submit
                      </button>
                    </center>

                    <p>
                      <b>Confidentiality Disclaimer:</b> This document contains
                      confidential communication/information and is soley
                      intended for the use of recipient. The contents of this
                      document may not be copied without written permission from
                      SARACA.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SurveyParticipantQualification;
